import actionTypes from './userSettings.actionTypes';

const initialState = {  
  language: 'en'
};


export default function(state = initialState, action){
  switch (action.type){    
    case actionTypes.UPDATE_USER_SETTINGS: return updateUserSettings(state, action);    
    case actionTypes.RESET_USER_SETTINGS: return resetState();
    default:
      return state;
  }
}


const updateUserSettings = (state, action) => {
  let language = action.data.language;
  return {
    ...state,    
    language: language
  };
};

const resetState = () => {
  return {
    ...initialState
  };
};